import axios from "axios";
// import { fetchBlogs } from "../api-urls"; // Ensure this path is correct
import { API_ENDPOINTS } from "../api-urls";


export const fetchBlogData = async () => {
  try {
    console.log("Fetching blogs data...");
    const response = await axios.get(API_ENDPOINTS.blogs);
    console.log("Full API Response:", response);

    if (response.status === 200 && response.data.data) {
      console.log("Extracted Blogs Data:", response.data.data);
      return { data: response.data.data, error: null };
    } else {
      console.error("Unexpected Response Status:", response.status);
      return { data: null, error: "Unexpected response status" };
    }
  } catch (error) {
    console.error("Error fetching blogs data:", error.response ? error.response.data : error.message);
    return { data: null, error: "Failed to load blogs" };
  }
};
